export default {
	twoWay: true,

	params: ['defaultValue'],

	bind() {
		$(this.el).find('.btn').each((index, element) => {
			$(element).on('click', event => {
				if ($(event.target).hasClass('disabled')) {
					return false;
				}

				let value = $(event.target).is('input') ? $(event.target).get(0).value : $(event.target).find('input').get(0).value;

				this.set(value);
			})
		});
	},

	update(value) {
		if (value) {
			this.set(value);

			$(this.el).find('.btn').each((index, element) => {
				$(element).removeClass('active');

				if ($(element).find('input').get(0).value === value) {
					$(element).addClass('active');
				}
			});
		} else {
			let input = $(this.el).find('.active').get(0);

			if (input) {
				this.set(input.value);
			} else {
				this.set(this.params.defaultValue || 0);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/directives/radio.js